module.exports = __webpack_public_path__ + "img/giffey-plagiat.d7d243b0.png";